import { Link } from 'react-router-dom'

const serviceLinks = [
  { to: '/services/professional-address', label: 'Professional Mailbox' },
  { to: '/services/virtual-address',       label: 'Virtual Business Address' },
  { to: '/services/part-time-office',      label: 'Part-Time Office Space' },
  { to: '/services/full-time-offices',     label: 'Full-Time Private Offices' },
  { to: '/services/conference-rooms',      label: 'Conference Rooms' },
]

const quickLinks = [
  { to: '/',          label: 'Home' },
  { to: '/about',     label: 'About' },
  { to: '/services',  label: 'Services' },
  { to: '/directory', label: 'Directory' },
  { to: '/contact',   label: 'Contact Us' },
  { to: '/booking',   label: 'Book a Room' },
  { to: '/members',   label: 'Member Portal' },
]

function FacebookIcon() {
  return (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
      <path d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 5 3.66 9.15 8.44 9.94v-7.03H7.9v-2.91h2.54V9.84c0-2.51 1.49-3.89 3.78-3.89 1.1 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56v1.87h2.78l-.45 2.91h-2.33V22c4.78-.79 8.44-4.94 8.44-9.94z" />
    </svg>
  )
}

export default function Footer() {
  return (
    <footer className="bg-ecbc-dark text-white/80">
      <div className="max-w-6xl mx-auto px-6 pt-12">
        <Link to="/" className="inline-flex items-center gap-2 mb-8">
          <picture>
            <source srcSet="/images/ECBC_logo_icon.webp" type="image/webp" />
            <img
              src="/images/ECBC_logo_icon.png"
              alt="East County Business Center — Est. 1987"
              className="h-[160px] w-auto"
              width="383"
              height="367"
            />
          </picture>
        </Link>
      </div>

      <div className="max-w-6xl mx-auto px-6 pb-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <h3 className="text-ecbc-sky font-semibold text-sm uppercase tracking-widest mb-3">Services</h3>
          <ul className="space-y-1.5 text-sm">
            {serviceLinks.map(({ to, label }) => (
              <li key={to}>
                <Link to={to} className="text-white/55 hover:text-ecbc-sky transition-colors duration-200">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-ecbc-sky font-semibold text-sm uppercase tracking-widest mb-3">Quick Links</h3>
          <ul className="space-y-1.5 text-sm">
            {quickLinks.map(({ to, label }) => (
              <li key={to}>
                <Link to={to} className="text-white/55 hover:text-ecbc-sky transition-colors duration-200">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-ecbc-sky font-semibold text-sm uppercase tracking-widest mb-3">Contact Info</h3>
          <ul className="space-y-1.5 text-sm text-white/55">
            <li>270 E Douglas Ave</li>
            <li>El Cajon, CA 92020</li>
            <li className="pt-1">
              <a href="tel:6194014000" className="hover:text-ecbc-sky transition-colors duration-200">
                (619) 401-4000
              </a>
            </li>
            <li>
              <a href="mailto:info@eastcountybiz.com" className="hover:text-ecbc-sky transition-colors duration-200">
                info@eastcountybiz.com
              </a>
            </li>
          </ul>
          <a
            href="https://www.facebook.com/ecbiz"
            target="_blank" rel="noopener noreferrer"
            aria-label="ECBC on Facebook"
            className="inline-flex mt-4 text-white/55 hover:text-ecbc-sky transition-colors duration-200"
          >
            <FacebookIcon />
          </a>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-6xl mx-auto px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-white/60">
          <span>© 2008–{new Date().getFullYear()} East County Business Center. All Rights Reserved.</span>
          <div className="flex items-center gap-4">
            <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" className="hover:text-ecbc-sky transition-colors duration-200">Privacy Policy</a>
            <a href="/terms-of-service" target="_blank" rel="noopener noreferrer" className="hover:text-ecbc-sky transition-colors duration-200">Terms of Service</a>
            <a href="/damage-waiver" target="_blank" rel="noopener noreferrer" className="hover:text-ecbc-sky transition-colors duration-200">Damage Waiver</a>
          </div>
        </div>
      </div>
    </footer>
  )
}
